/**
 * Parse international breakdown keys (e.g. "CA-BC", "GB") into country + optional region.
 */
export function parseCountryReportRoute(code: string): { countryCode: string; regionCode?: string } {
  const upper = String(code || '').trim().toUpperCase();
  if (!upper) {
    return { countryCode: '' };
  }

  const dashIdx = upper.indexOf('-');
  if (dashIdx > 0) {
    const countryCode = upper.slice(0, dashIdx);
    const regionCode = upper.slice(dashIdx + 1);
    if (countryCode.length === 2 && regionCode.length === 2) {
      return { countryCode, regionCode };
    }
  }

  return { countryCode: upper.length >= 2 ? upper.slice(0, 2) : upper };
}

/** Router link segments for the country sales report page. */
export function countrySalesReportRouterLink(code: string): string[] {
  const { countryCode, regionCode } = parseCountryReportRoute(code);
  if (!countryCode) {
    return ['/sales-report/country'];
  }
  return regionCode
    ? ['/sales-report/country', countryCode, regionCode]
    : ['/sales-report/country', countryCode];
}

/** Router link segments for editing country nexus by breakdown key (e.g. CA-BC, IE). */
export function countryNexusRouterLink(code: string): string[] {
  const { countryCode } = parseCountryReportRoute(code);
  if (!countryCode) {
    return ['/account-settings/country-nexus'];
  }
  return ['/account-settings/country-nexus', countryCode];
}

/** Query params when country nexus is province-scoped (CA provinces). */
export function countryNexusQueryParams(code: string): { region?: string } {
  const { regionCode } = parseCountryReportRoute(code);
  return regionCode ? { region: regionCode } : {};
}
